export default "__VITE_ASSET__DCwp06jv__"